var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-video-tailoring__cutting-point"},[_c('div',{staticClass:"vh-video-tailoring__point",style:({ left: _vm.pointPosition + 'px' }),on:{"click":_vm.deletePoint}})])
}
var staticRenderFns = []

export { render, staticRenderFns }